export const SHOWROOM_ROUTE = "/"
export const PARTICULARES_ROUTE = "/vehiculos-particulares"
export const COMERCIALES_ROUTE = "/vehiculos-comerciales"